<template>
  <div
    class="display-modal"
    :class="{ 'is-mounted': hasModalData }"
    @click.stop="onShadowClick"
    id="modal-shadow"
  >
    <div>
      <div class="modal-header row between">
        <h3 class="strong">
            {{ $store.getters.modal.header }}
        </h3>
        <div>
          <button @click="closeModal" class="red p-5">x</button>
        </div>
      </div>
      <component
        :is="$store.getters.modal.component"
        v-if="hasModalData"
        class="modal-content"
        :props="$store.getters.modal.props"
      />
      <div class="right controls">
        <button
          @click="cancelClick"
          class="red p-5"
          v-if="!$store.getters.modal.hideBadClick"
        >
          Cancel
        </button>
        <button
          @click="okayClick"
          class="green p-5"
          v-if="!$store.getters.modal.hideGoodClick"
        >
          Okay
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  computed: {
    hasModalData() {
      const hasData = this.$store.getters.modal.mounted;
      return hasData;
    }
  },
  methods: {
    closeModal() {
      this.$store.commit("setModal", null);
    },
    onShadowClick(e) {
      e.target.id && e.target.id === "modal-shadow" && this.closeModal();
    },
    okayClick() {
      if (this.$store.getters.modal.goodClick) {
        this.$store.getters.modal.goodClick();
      }
      this.closeModal();
    },
    cancelClick() {
      if (this.$store.getters.modal.badClick) {
        this.$store.getters.modal.badClick();
      }
      this.closeModal();
    }
  }
};
</script>

<style lang="scss" scoped>
.display-modal {
  opacity: 0;
  position: fixed;
  height: 0;
  width: 0;
  overflow: hidden;
  top: -300px;
  left: -300px;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 20;
  justify-content: center;
  align-items: center;
  display: relative;
  & > div {
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    max-height: 60vh;
    max-width: 500px;
    width: calc(95% - 20px);
    background-color: #fff;
    position: relative;
    opacity: 0;
    top: -100px;
    transition: all 0.2s;
  }
  &.is-mounted {
    opacity: 1;
    display: flex;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    & > div {
      opacity: 1;
      top: 0;
      display: flex;
      flex-flow: column;
    }
  }
  .modal-header {
    margin-bottom: 10px;
    h3 {
      font-size: 1.2rem;
      margin: 0;
      padding-top: 5px;
      padding-left: 5px;
      color: #888;
    }
    div {
      padding-top: 2px;
      button {
        height: 22px;
        width: 22px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .modal-content {
    flex: 1;
    overflow: auto;
  }
  .controls {
    margin-top: 10px;
    button {
      padding: 8px 20px;
      margin-left: 20px;
    }
  }
}
</style>
